// PANAS constants and data
export const part1 = [
  'Interested+',
  'Distressed-',
  'Excited+',
  'Upset-',
  'Strong+',
  'Guilty-',
  'Scared-',
  'Hostile-',
  'Enthusiastic+',
  'Proud+',
  'Irritable-',
  'Alert+',
  'Ashamed-',
  'Inspired+',
  'Nervous-',
  'Determined+',
  'Attentive+',
  'Jittery-',
  'Active+',
  'Afraid-',
]

export const part2 = `Belief in a higher power+
Anxious-
Follow my intuition+
Mindful+
Poor Me-
Self-Aware+
Suppress Emotions-
Confident+
Depressed-
Judge self and others-
Frustrated-
Embrace social support+
Unworthy-
Have strong reasons for living+
Fear of rejection or shame-
Hopeful+
Powerless-
Take control of my health+
Grateful+
Fear of disability or death-`.split('\n')

export const modifiedPanas = [
  'Hopeful+',
  'Angry-',
  'Guilty-',
  'Follow my intuition+',
  'Determined+',
  'Worried/Stressed-',
  'Depressed-',
  'Grateful+',
  'Unworthy-',
  'Have strong reasons for living+',
  'Powerless/Frustrated-',
  'Take control of my health+',
  'Ashamed/Embarassed-',
  'Self-aware of thoughts & feelings+',
  'Feel like a victim/Why me?-',
  'Embrace Social Support+',
  'Fear of Disability or Death-',
  'Spiritual or belief in higher power+',
  'Judgmental of Self & Others-',
  'Enjoy Life+',
]

export const modifiedPanasQuestionOptions = [
  { label: 'None of the time', score: 1 },
  { label: 'Sometimes', score: 2 },
  { label: 'Moderate', score: 3 },
  { label: 'Most of the time', score: 4 },
  { label: 'Always', score: 5 },
]

export const basicSelectQuestions = [
  {
    name: 'believeCanGetWell' as const,
    question: 'I believe I can get well.',
  },
  {
    name: 'deserveToGetWell' as const,
    question: 'I deserve to get well.',
  },
  {
    name: 'takingAction' as const,
    question: 'I am taking action to get well.',
  },
]

export const partAQuestions = [
  {
    name: 'positiveThoughts' as const,
    question: 'What percentage of the day are you thinking positive thoughts?',
  },
  {
    name: 'fearOrWorry' as const,
    question:
      'What percentage of the day are you in a state of stress, fear, worry, or anxiety?',
  },
  {
    name: 'forgiveOthers' as const,
    question: 'What percentage have you forgiven other people and situations?',
  },
  {
    name: 'forgiveSelf' as const,
    question:
      'What percentage have you forgiven yourself for anything, current or past?',
  },
  {
    name: 'releaseTrauma' as const,
    question: 'What percentage of past trauma have you released?',
  },
]
